import type { PropsWithChildren, ReactNode } from 'react';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Box } from '@interxfi/design-system/components/box/box';
import { Typography } from '@interxfi/design-system/components/typography';
import styles from './card-form-group.module.scss';

interface CardFormGroupProps {
  icon?: ReactNode;
  title: string;
}

function CardFormGroup({ children, icon, title }: PropsWithChildren<CardFormGroupProps>) {
  return (
    <Box borderRadius="8px" className={styles.cardFormGroup}>
      <VerticalStack>
        <HorizontalStack blockAlign="center" className={styles.header} gap={2} wrap="nowrap">
          {icon}

          <Typography lineHeight="1.5rem" size="0.875rem">
            {title}
          </Typography>
        </HorizontalStack>

        {children}
      </VerticalStack>
    </Box>
  );
}

CardFormGroup.Section = function CardFormGroupSection({ children, toggleInputElement }: PropsWithChildren<{ toggleInputElement?: ReactNode }>) {
  return (
    <VerticalStack className={styles.section} gap={2}>
      {toggleInputElement ? <div className={styles.toggleContainer}>{toggleInputElement}</div> : null}
      {children ? (
        <VerticalStack className={styles.inputContainer} gap={2}>
          {children}
        </VerticalStack>
      ) : null}
    </VerticalStack>
  );
};

export { CardFormGroup };
